import { initializeApp } from 'firebase/app';
import { getDatabase, push, ref, set } from 'firebase/database';
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCfpNAohjDjJqi8U6HKGx5x7ayIn4RSgxk',
  authDomain: 'chef-margaro-e-c.firebaseapp.com',
  databaseURL: 'https://chef-margaro-e-c-default-rtdb.firebaseio.com',
  projectId: 'chef-margaro-e-c',
  storageBucket: 'chef-margaro-e-c.firebasestorage.app',
  messagingSenderId: '206604835946',
  appId: '1:206604835946:web:62a0d697964ce039adfe13',
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app);

export async function uploadPaymentProof(file) {
  const extension = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
  const objectRef = storageRef(
    storage,
    `payments/${Date.now()}-${Math.random().toString(36).slice(2, 10)}.${extension}`
  );
  await uploadBytes(objectRef, file, { contentType: file.type || 'image/jpeg' });
  return getDownloadURL(objectRef);
}

export async function notifyNewPayment({ paymentId, orderId } = {}) {
  const payload = { created_at: Date.now() };
  if (paymentId) payload.payment_id = Number(paymentId);
  if (orderId) payload.order_id = Number(orderId);
  const created = push(ref(database, 'payments'));
  await set(created, payload);
}
